<form [formGroup]="formGroup">
  <div class="jobbing-upsert-form-wrapper">

    <div class="item rounded job-information-form-wrapper">
      <app-job-information-form [formGroup]="formGroup" [freightPayers]="freightPayers$ | async"
        [servicePromiseOptions]="servicePromiseOptions$ | async" [resetEmitter]="resetEmitter"
        [priorityOptions]="priorityOptions$ | async"></app-job-information-form>
    </div>


    <div class="item rounded notification-form-wrapper">
      <app-notification-form [formGroup]="formGroup"></app-notification-form>
    </div>

    <div class="item rounded job-from-form-wrapper">
      <app-from-location-form [resetEmitter]="resetEmitter" [formGroup]="formGroup"></app-from-location-form>
    </div>

    @if(!isOnSite()){
    <div class="item rounded job-to-form-wrapper">
      <app-to-location-form [formGroup]="formGroup"></app-to-location-form>
    </div>
    }

    <div class="item rounded product-information-from-wrapper">
      <app-product-information-form [startingProducts]="startingProducts" [resetEmitter]="resetEmitter"
        [defaultEmitter]="productDefaultEmitter" [formGroup]="formGroup"></app-product-information-form>
    </div>
    <div class="item rounded job-documents-wrapper" [ngClass]="isOnSite() ? 'onsite' : 'offsite'">
      <app-jobbing-attachment-form [formGroup]="formGroup"></app-jobbing-attachment-form>
    </div>

    <div class="item rounded text-md-end form-footer-wrapper">

      <button class="btn btn-danger me-2" (click)="clearForm()">Clear Form</button>
      <button class="btn btn-primary me-2" (click)="saveDefaults()">Save Defaults</button>
      <button class="btn btn-primary me-2" (click)="clearDefaults()">Clear Defaults</button>


      @if (!isEdit) {
      @if(orderCreatedSuccessMode){
      <button class="btn btn-success" (click)="clearAndCreate()">
        Clear & Create New Job
      </button>
      }@else{
      <button class="btn btn-success" (click)="submit()">
        Save
      </button>
      }
      } @else {
      <button class="btn btn-success" (click)="submit()" [disabled]="!formGroup.dirty">
        Update
      </button>
      }
    </div>
  </div>
</form>
